export const humanMessageLabel = (
  senderName: string | undefined,
  currentUserName: string | undefined,
): string => {
  if (!senderName) return 'Agent';
  if (
    currentUserName
    && senderName.trim().toLowerCase() === currentUserName.trim().toLowerCase()
  ) {
    return 'You';
  }
  return senderName;
};
